import "@yzfe/svgicon/lib/svgicon.css";
import CustomVueSvgIcon from "../components/YzfeIcon.vue";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("icon", CustomVueSvgIcon);
  nuxtApp.vueApp.component("Icon", CustomVueSvgIcon);
  nuxtApp.vueApp.component("SvgIcon", CustomVueSvgIcon);
});
